module.exports = require("object-hash");